/* eslint-disable import/no-unused-modules */
import CheckIcon from '@mui/icons-material/Check'
import ClearIcon from '@mui/icons-material/Clear'
import DeleteIcon from '@mui/icons-material/Delete'
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox'
import {
  Avatar,
  Box,
  Button,
  Drawer,
  Grid,
  IconButton,
  Tooltip,
} from '@mui/material'
import Stack from '@mui/material/Stack'
import confirmationAlert from 'components/Common/ConfirmAlert/ConfirmAlert'
import { maskPhoneNumber } from 'components/Common/Phone/displayPhone'
import useDebounce from 'hooks/useDebounce'
import {
  grayColor,
  successColor,
} from 'materialUI/jss/material-dashboard-pro-react'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import {
  deleteUser,
  getUsersByClientId,
  getUsersBySupplierId,
  // registerUser,
  resendEmailConfirmation,
} from '../../../../reducers/usersReducer'
import BasicTable from '../../../Common/Tables/BasicTable/BasicTable'

import { Edit } from '@mui/icons-material'
import InviteUser from './InviteUser'
import UpdateUser from './UpdateUser'
import styles from './usersStyle'

export const allRoles = [
  {
    label: 'Jyrney Admin',
    value: 1,
    adminOnly: true,
  },
  {
    label: 'Client Admin',
    value: 10,
  },
  {
    label: 'Traveller',
    value: 13,
  },
  // {
  //   label: 'Client Support',
  //   value: 2,
  // },
  // {
  //   label: 'Supplier Support',
  //   value: 3,
  // },
  // {
  //   label: 'Operations Support',
  //   value: 4,
  // },
  // {
  //   label: 'Operations Support Supervisor',
  //   value: 5,
  // },
  // {
  //   label: 'Booker',
  //   value: 6,
  // },
  {
    label: 'Travel Consultant',
    value: 11,
  },
  {
    label: 'Senior Travel Consultant',
    value: 12,
  },
  {
    label: 'Passenger',
    value: 14,
  },
  // {
  //   label: 'Supplier Admin',
  //   value: 20,
  // },
  // {
  //   label: 'Dispatcher',
  //   value: 21,
  // },
  // {
  //   label: 'Operator',
  //   value: 22,
  // },
  {
    label: 'Platform Admin',
    value: 23,
    adminOnly: true,
  },
]

export const standardRoles = allRoles.filter((v) => v.adminOnly !== true)

interface UsersProps {
  client: any
}

export function Users(props: UsersProps) {
  console.log('userProps', props)
  const dispatch = useDispatch()
  const client = props.client
  const [dirtyDrawer, setDirtyDrawer] = React.useState(false)
  const [newUserOpenDrawer, setNewUserOpenDrawer] = React.useState(false)
  const [updateUserOpenDrawer, setUpdateUserOpenDrawer] = React.useState(false)
  const [selectedUser, setSelectedUser] = React.useState<any>()

  const isSupplier = props.client.regionName

  const [allUsers, setAllUsers] = React.useState([])

  const currentUser = useSelector((state: any) => state.users.user)

  const getUsersForClient = async () => {
    const users = [] as any

    if (isSupplier) {
      dispatch(getUsersBySupplierId(props.client.id)).then((result: any) => {
        if (!result.error) {
          result.payload.forEach((user: any) => {
            users.push({
              ...user,
            })
          })

          setAllUsers(users)
        }
      })
    } else {
      dispatch(getUsersByClientId(props.client.id)).then((result: any) => {
        console.log('all users result', result)
        if (!result.error) {
          result.payload.forEach((user: any) => {
            users.push({
              ...user,
            })
          })

          setAllUsers(users)
        }
      })
    }
  }

  useEffect(() => {
    getUsersForClient()
  }, [])

  const onDeleteUser = (User: any) => {
    confirmationAlert({
      title: 'Disable User',
      action: async function (): Promise<void> {
        dispatch(deleteUser(User.row.original.userId)).then((result: any) => {
          if (!result.error) {
            getUsersForClient()
          }
        })
      },
      confirmationMessage:
        'This action will permanently disable ths user account.',
      confirmationQuestion: 'Are you sure you want to proceed?',
      noButtonText: 'Cancel',
      yesButtonText: 'Disable User',
      yesButtonColor: 'error',
    })
  }

  const onDirtyClose = (closeDrawer: (open: boolean) => void) => {
    confirmationAlert({
      title: 'Are you sure you want to exit?',
      action: async function (): Promise<void> {
        setDirtyDrawer(false)
        closeDrawer(false)
      },
      confirmationMessage:
        "You've made changes to this user, that haven't yet been saved.",
      confirmationQuestion: 'Are you sure you want to proceed?',
      noButtonText: 'Go back',
      yesButtonText: 'Discard Changes',
      yesButtonColor: 'error',
    })
  }

  const onResendEmailConfirmation = (User: any) => {
    dispatch(resendEmailConfirmation(User.row.original.userId)).then(
      (result: any) => {
        if (!result.error) {
          getUsersForClient()
        }
      },
    )
  }

  const columns = React.useMemo(
    () => [
      {
        Header: 'User List',
        columns: [
          {
            Header: 'First Name',
            accessor: 'firstName',
            show: false,
            sortable: true,
          },
          {
            Header: 'Last Name',
            accessor: 'lastName',
            sortable: true,
          },
          {
            Header: 'Email',
            accessor: 'email',
            Cell: (props: any) => {
              const email = props.cell.value
              const mobileNumber = props.row.original.contact?.mobileNumber
              return email
                ? email
                : mobileNumber
                ? maskPhoneNumber(mobileNumber)
                : ''
            },
          },
          {
            Header: 'Roles',
            accessor: 'roles',
            Cell: (props: any) => {
              const roles = props.cell.value.map((role: string) => {
                return role.replaceAll('_', ' ')
              })
              return roles.join(', ')
            },
          },
          {
            Header: 'Travel Policy',
            accessor: 'travelPolicyId',
            Cell: (props: any) => {
              const travelPolicies =
                client?.travelPolicies?.value ?? client?.travelPolicies ?? []
              const travelPolicy = travelPolicies.find(
                (p: any) => p?.id === props.cell.value,
              )
              return travelPolicy?.name ?? travelPolicy?.label ?? 'None'
            },
          },
          {
            Header: 'Confirmed',
            sortable: true,
            accessor: 'emailConfirmed',
            filterable: false,
            Cell: (props: any) => {
              return (
                <>
                  <Avatar
                    sx={{
                      backgroundColor:
                        props.cell.row.values.firstName &&
                        props.cell.row.values.lastName
                          ? successColor
                          : grayColor,
                    }}
                  >
                    {props.cell.row.values.firstName &&
                    props.cell.row.values.lastName ? (
                      <CheckIcon />
                    ) : (
                      <ClearIcon color="error" />
                    )}
                  </Avatar>
                </>
              )
            },
          },
          {
            Header: 'Actions',
            accessor: 'actions',
            sortable: false,
            filterable: false,
            Cell: (props: any) => {
              return (
                <div style={{ textAlign: 'left' }}>
                  <Stack direction="row" spacing={2} alignItems={'center'}>
                    <Tooltip title="Edit User">
                      <IconButton
                        size="large"
                        onClick={() => {
                          console.log(props.row.original)
                          setSelectedUser(props.row.original)
                          setUpdateUserOpenDrawer(true)
                        }}
                      >
                        <Edit />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Resend Email Confirmation">
                      <IconButton
                        size="large"
                        onClick={() => onResendEmailConfirmation(props)}
                      >
                        <ForwardToInboxIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete User">
                      <IconButton
                        size="small"
                        onClick={() => onDeleteUser(props)}
                      >
                        <DeleteIcon color="error" />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </div>
              )
            },
          },
        ],
      },
    ],
    // update when current user, client or updating state changes
    [currentUser, client],
  )

  const hiddenColumns = () => {
    let hideColumn = []

    if (!client.travelPolicies) hideColumn.push('travelPolicyId')
    return hideColumn
  }

  return (
    <Box component={'div'} sx={styles.root}>
      <Button
        onClick={() => setNewUserOpenDrawer(true)}
        sx={styles.button}
        variant="outlined"
      >
        Create New Account
      </Button>

      <Grid container>
        <Grid item xs={12} sx={styles.table}>
          <BasicTable
            columns={columns}
            data={allUsers}
            hideColumns={hiddenColumns()}
          />
        </Grid>
      </Grid>
      <Drawer
        anchor={'right'}
        open={useDebounce(newUserOpenDrawer, 500)}
        onClose={() => {
          if (dirtyDrawer) {
            onDirtyClose(setNewUserOpenDrawer)
          } else {
            setNewUserOpenDrawer(false)
            setDirtyDrawer(false)
          }
        }}
        PaperProps={{ sx: { width: '700px', backgroundColor: '#F8F8F8' } }}
      >
        <InviteUser
          closeDrawer={() => {
            setNewUserOpenDrawer(false), getUsersForClient()
          }}
          setDirtyDrawer={setDirtyDrawer}
          client={props.client}
        />
      </Drawer>
      <Drawer
        anchor={'right'}
        open={useDebounce(updateUserOpenDrawer, 500)}
        onClose={() => {
          if (dirtyDrawer) {
            onDirtyClose(setUpdateUserOpenDrawer)
          } else {
            setUpdateUserOpenDrawer(false)
            setDirtyDrawer(false)
          }
        }}
        PaperProps={{ sx: { width: '700px', backgroundColor: '#F8F8F8' } }}
      >
        {selectedUser && (
          <UpdateUser
            closeDrawer={() => {
              setUpdateUserOpenDrawer(false), getUsersForClient()
            }}
            client={props.client}
            setDirtyDrawer={setDirtyDrawer}
            user={selectedUser}
          />
        )}
      </Drawer>
    </Box>
  )
}

Users.propTypes = {
  client: PropTypes.object.isRequired,
}

const mapStateToProps = (state: any) => ({
  currentUser: state.users.user,
})

export default connect(mapStateToProps)(Users)
